import React from "react";

import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import ArrowForward from "@mui/icons-material/ArrowForward";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "notistack";

import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

import SvgIconStyle from "../../../components/SvgIconStyle";

import CartItemEventos from "../CartItem/CartItemEventos";

import {
  clearCart,
  setDonationTab,
  updateDonation,
  clearDonationCart,
  getDonation,
  addProduct,
  addEventProduct,
  setRecolhaDate,
  setStartDate,
  setEndDate,
  setSelectProductError,
  setAnimalEndDate,
  addCollectorInviteForDonation,
  addRating
} from "../slice";

import {
  drawerStyles,
  mainBoxStyles,
  avataStyles,
  svgIconStyle,
  buttonBoxStyles,
  buttonBoxStyles2,
  lockButtonStyles,
  lockIconStyles,
} from "./styles";
import {
  getMyActiveDonation,
  setMyActiveDonationsLimit,
  setMyActiveDonationsOffset,
  setMyActiveDonationsPage,
} from "../../DashBoardView/slice";

import {
  getDonorDetailById,
  updateCollection,
} from "../../CreateCollection/slice";
import {
  ComponentType,
  DonationStatus,
  EntityType,
  units,
} from "../../../common/enum";
import {
  setConfirmationDialog,
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
} from "../../AdminView/adminSlice";
import TextField from "@mui/material/TextField";
	import Rating from "@mui/material/Rating";
  import { useData } from '../../OnBoarding/DataContext';
  import { useCollection } from "../../DashBoardView/Actions/ActionDate/useCollection";
export default function Cart({ t, open, setOpen }) {
  const { sharedData } = useData();
  const {donationIDEventos , numberBenef , collectionEventos , motiveEventos,ratingEventos} = sharedData;
  const {
    auth: { profile },
    auth,
  } = useSelector((state) => state);
  const { userId, entityId } = auth.user || "";
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setMonthStartDate, setMonthEndDate, setKey } = useCollection();
  const [motiveValue, setMotiveValue] = React.useState("");
  const [ratingValue, setRatingValue] = React.useState(0);
  
  const {
    donationCart: {
      products: items,
      donationTab,
      donationId,
      updateDonationDetail,
      collectorInviteNames,
    },
    auth: {
      profile: { entity },
    },
  } = useSelector((state) => state);

  const onClearCart = (e, itemID) => {
    e.preventDefault();
    dispatch(setConfirmationDialog(true));
  };

  const previousTabHandler = React.useCallback(() => {
    dispatch(setDonationTab("product"));
  }, [dispatch]);

  const addCollectorInvite = () => {
    const payload = {
      id: 0,
      donationId: donationId,
      collectorEntityId: collectorInviteNames.map((n) => n?.entity?.entityId),
      sentBy: entity?.entityId,
      status: "INVITED",
    };

    dispatch(addCollectorInviteForDonation(payload));
  };

  const onContinue = async () => {
    switch (donationTab.toString()) {
      case "product":
        if (items.length > 0) {
          dispatch(setSelectProductError(false));
          dispatch(setDonationTab("collection"));
        } else {
          dispatch(setSelectProductError(true));
        }
        break;
      case "collection":
        if(sharedData.numberBenef != null && sharedData.numberBenef != "" && $("#motivoEventos").val() != null && $("#motivoEventos").val() != ""){
          setMotiveValue($("#motivoEventos").val());
          setRatingValue(sharedData.ratingEventos);
          const payload = {
            donationId: sharedData.donationIDEventos,
            productId: null,
            totalProductQuantity: null,
            unit: null,
            entityId: profile?.entity?.entityId,
            numberBeneficiary: parseInt(sharedData.numberBenef)
          };
          dispatch(addEventProduct(payload)) .unwrap()
          .then((res) => {
            updatingCollection(sharedData)
          }).catch(() => {
            enqueueSnackbar({
              message: t("someThingWentWrong"),
              variant: "error",
            });
          });
        }else{
          enqueueSnackbar({
            message: "Todos os campos são de preenchimento obrigatório",
            variant: "error",
          });
          // dispatch(setSelectProductError(true));
          // dispatch(setDonationTab("product"));

        }
        break;
    }
  };

  const updatingCollection = React.useCallback(
    async (status) => {
      let payload = {};
      payload["collectionId"] = sharedData.collectionEventos?.collection.id;
      payload["addressId"] = sharedData.collectionEventos?.collection.collectionAddressId;
      payload["status"] = 'COLLECTED';
      payload["motive"] =  status.motiveEventos;
      payload["dateOfCollection"] = sharedData.collectionEventos?.collection.dateOfCollection;
      payload["updatedBy"] = userId;
      await dispatch(updateCollection(payload))
        .unwrap()
        .then(async (res) => {
            rateCollectionDonation(status.motiveEventos , status.ratingEventos);
        })
        .catch(() => {
          enqueueSnackbar({
            message: t("someThingWentWrong"),
            variant: "error",
          });
        });
    },
    [ motiveValue, ratingValue , sharedData]
  );

  const rateCollectionDonation = React.useCallback((motiveEventos ,ratingEventos) => {
    const payload = {
      donationId: sharedData.donationIDEventos,
      collectionId: sharedData.collectionEventos?.collection.id,
      createdBy: userId,
      rating: ratingEventos,
      feedback: motiveEventos,
    };
    
    dispatch(addRating(payload))
    enqueueSnackbar({
      message: t("collectionFeedbackSuccessfully"),
      variant: "success",
    });
    navigate("/dashboard");
    dispatch(clearDonationCart());
      // .unwrap()
      // .then((res) => {
        
      // })
      // .catch(() => {
      //   enqueueSnackbar({
      //     message: t("someThingWentWrong"),
      //     variant: "error",
      //   });
      // });
  }, [ratingValue , motiveValue]);

  const onClose = React.useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  return (
    <Drawer
      variant={mobile ? "temporary" : "permanent"}
      anchor="right"
      sx={drawerStyles}
      open={mobile ? open : true}
      onClose={onClose}
    >
      <Box sx={mainBoxStyles}>
        {items.length > 0 && (
          <Box sx={{ display: "flex" }}>
            <Avatar sx={avataStyles}>
              <SvgIconStyle src="/static/dashboard/box.svg" sx={svgIconStyle} />
            </Avatar>
            <Box sx={{ paddingLeft: "10px", mb: 6 }}>
              <Typography
                sx={{ marginTop: "10px" }}
                fontWeight="bold"
                fontSize={"large"}
              >
                {t("Articles")}
              </Typography>
              <Typography>{'Lista de artigos que foram doados'}</Typography>
            </Box>
          </Box>
        )}
        {mobile && (
          <Button sx={{ minWidth: "0px" }} onClick={onClose}>
            <CloseRoundedIcon />
          </Button>
        )}
      </Box>
      {items.length > 0 ? (
        <Box
          sx={{
            height: "78vh",
            overflow: "hidden",
            overflowY: "scroll",
            scrollbarColor: "#37b34a #e4fbe7",
            scrollBehavior: "smooth",
            paddingBottom: "30%",
            pr: 2,
            "&::-webkit-scrollbar": {
              height: 1,
              width: 12,
              background: "#e4fbe7",
            },

            "&::-webkit-scrollbar-thumb": {
              background: "#37b347",
              "-webkit-border-radius": "1ex",
              // "-webkit-box-shadow": "0px 1px 2px rgba(0, 0, 0, 0.75)",
            },

            "&::-webkit-scrollbar-corner": {
              background: "#e4fbe7",
            },
          }}
        >
          {" "}
          {items.map((item) => {
            return (
              <CartItemEventos
                item={item}
                t={t}
                key={item.productId}
                component={ComponentType.CART_PRODUCT}
              />
            );
          })}
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "50%",
          }}
        >
          <Avatar sx={avataStyles}>
            <SvgIconStyle src="/static/dashboard/box.svg" sx={svgIconStyle} />
          </Avatar>
          <Box sx={{ paddingLeft: "10px" }}>
            <Typography sx={{ marginTop: "10px" }}>
              {t("emptyCart")} :(
            </Typography>
          </Box>
        </Box>
      )}
     <Box sx={buttonBoxStyles}>
        {/* <Button sx={lockButtonStyles} onClick={(e) => onClearCart(e)}>
          <SvgIconStyle src="/static/dashboard/lock.svg" sx={lockIconStyles} />
        </Button> */}
        <Box>
          {donationTab.toString() === "collection" && (
            <Button
              onClick={previousTabHandler}
              sx={{
                mr: 1,
                borderRadius:"4px"
              }}
              size="large"
              variant="contained"
              color="grey"
              startIcon={<ArrowBackIcon fontSize="16px" />}
            >
              <Typography variant="bold">{t("toGoBack")}</Typography>
            </Button>
          )}
          <Button
            size="large"
            variant="contained"
            onClick={() => onContinue()}
            endIcon={
              donationTab.toString() === "collection" ? (
                <CheckCircleOutlineOutlinedIcon fontSize="16px" />
              ) : (
                <ArrowForward fontSize="16px" />
              )
            }
            sx={{borderRadius:"4px"}}
          >
            <Typography variant="bold">
              {donationTab.toString() === "collection"
                ? "Finalizar"
                : "Continuar"}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
